export default __webpack_public_path__ + "static/media/notion_icon.f81a1ac4.svg";